export default class ExportRequest {
	constructor({
		id,
		data,
		dest,
		status,
		process,
		created,
		details,
		sample_url: sampleUrl,
		url,
	} = {}) {
		this._id = id;
		this._data = data;
		this._dest = dest;
		this._status = status;
		this._process = process;
		this._created = created;
		this._details = details;
		this._sample_url = sampleUrl;
		this._url = url;
	}

	getKey = () => String(this._id);

	getDest = () => this._dest;

	isDone() {
		return this._status === 'done';
	}

	getStatus = () => this._status;

	getProcess = () => this._process;

	getCreated = () => this._created;

	getDetails = () => this._details;

	getSampleUrl = () => this._sample_url;

	getUrl = () => this._url;
}
